import { useQuery } from "react-query";

import { GET_CALENDAR_SESSIONS } from "@constants/reactQueryKeys";
import { getCalendarSessionsByDates } from "api/video";
/** @typedef {import("react-query").UseQueryResult} UseQueryResult */

/**
 * Custom hook to fetch calendar sessions by dates.
 *
 * @param {Object} details - The details object containing startDate, endDate, and userId.
 * @param {string} details.startDate - The start date in ISO format.
 * @param {string} details.endDate - The end date in ISO format.
 * @param {number[]|string[]} details.userIdList - The list of user IDs to fetch the calendar sessions for.
 * @returns {UseQueryResult} - The result of the useQuery hook.
 */
export const useCalendarSessionsByDates = ({ startDate, endDate, userIdList }) => {
  const cleanList = userIdList.filter(Boolean); // Remove any falsy values from the list
  const queryDetails = { startDate, endDate, userIdList: cleanList };
  return useQuery(
    [GET_CALENDAR_SESSIONS, queryDetails],
    () => getCalendarSessionsByDates(queryDetails),
    {
      enabled: !!startDate && !!endDate && cleanList.length > 0,
    }
  );
};
